import { Card, Grid, Inline, Skeleton, Stack } from '@cortex/ui';

function StatCardSkeleton() {
  return (
    <Card className="p-4">
      <Stack gap="sm">
        <Inline justify="between">
          <Skeleton className="h-3.5 w-[100px]" />
          <Skeleton className="h-8 w-8" />
        </Inline>
        <Skeleton className="h-7 w-[60px]" />
      </Stack>
    </Card>
  );
}

export function StatCardSkeletonRow() {
  return (
    <Grid gap="md" columns={2} className="lg:grid-cols-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <StatCardSkeleton key={i} />
      ))}
    </Grid>
  );
}
